var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tw-bg-blue-100 tw-text-blue-gray-700",style:({ width: '24px', height: '24px' })},[_c('span',[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }